(() => {
  const toggle = document.getElementById('mobile-nav-toggle');
  const dialog = document.getElementById('mobile-nav');
  if (!toggle || !dialog) return;

  const panelRoot = dialog.querySelector('[data-menu-panel-stack]');
  const closeBtn = dialog.querySelector('[data-menu-close]');

  const focusableSelector =
    'a[href],button:not([disabled]),[role="button"],input:not([type="hidden"]),select,textarea,[tabindex]:not([tabindex="-1"])';

  function lockScroll() {
    window.ScrollLock?.lock({ background: true, restoreScroll: true });
  }

  function unlockScroll() {
    window.ScrollLock?.unlock({ background: true, restoreScroll: true });
  }

  const panels = new Map();
  panelRoot?.querySelectorAll('[data-menu-panel]').forEach(panel => {
    const id = panel.getAttribute('data-menu-panel');
    if (id) panels.set(id, panel);
  });

  if (!panels.size || !panels.has('main')) return;

  let stack = ['main'];

  // Apply translate classes to the panel based on stack position
  function setPanelState(panel, state) {
    panel.classList.remove('translate-x-0', 'translate-x-full', '-translate-x-full', 'pointer-events-none');

    if (state === 'active') {
      panel.classList.add('translate-x-0');
      panel.setAttribute('aria-hidden', 'false');
      return;
    }

    panel.classList.add(state === 'prev' ? '-translate-x-full' : 'translate-x-full', 'pointer-events-none');
    panel.setAttribute('aria-hidden', 'true');
  }

  function applyStates(activeId) {
    panels.forEach((panel, id) => {
      const stackIndex = stack.indexOf(id);
      if (id === activeId) {
        setPanelState(panel, 'active');
      } else if (stackIndex !== -1 && stackIndex < stack.length - 1) {
        setPanelState(panel, 'prev');
      } else {
        setPanelState(panel, 'next');
      }
    });
  }

  function focusActivePanel() {
    const activePanel = panels.get(stack[stack.length - 1]);
    if (!activePanel) return;

    const focusTarget = activePanel.querySelector(focusableSelector) || activePanel;
    focusTarget.focus?.();
  }

  // Initialise panel positions so everything is hidden except main
  applyStates('main');

  let lastFocused = null;

  function openMenu() {
    lastFocused = document.activeElement;

    if (!dialog.open) dialog.show();

    toggle.setAttribute('aria-expanded', 'true');
    lockScroll();
    applyStates(stack[stack.length - 1]);
    requestAnimationFrame(focusActivePanel);
  }

  function closeMenu() {
    if (dialog.open) dialog.close();

    toggle.setAttribute('aria-expanded', 'false');
    unlockScroll();
    lastFocused?.focus?.();
    lastFocused = null;
    stack = ['main'];
    applyStates('main');
  }

  // Listeners
  toggle.addEventListener('click', () => (dialog.open ? closeMenu() : openMenu()));

  closeBtn?.addEventListener('click', event => {
    event.preventDefault();
    closeMenu();
  });

  dialog.addEventListener('cancel', event => {
    event.preventDefault();
    closeMenu();
  });

  dialog.addEventListener('close', () => toggle.setAttribute('aria-expanded', 'false'));

  dialog.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (link) closeMenu();

    const control = event.target.closest('[data-menu-target],[data-menu-back]');
    if (!control) return;

    // Forward navigation pushes the panel id on the stack
    if (control.hasAttribute('data-menu-target')) {
      event.preventDefault();
      const targetId = control.getAttribute('data-menu-target');

      if (!targetId || !panels.has(targetId)) return;
      if (stack[stack.length - 1] === targetId) return;

      stack.push(targetId);
      applyStates(targetId);
      focusActivePanel();

      return;
    }

    if (control.hasAttribute('data-menu-back')) {
      event.preventDefault();
      if (stack.length <= 1) return;

      stack.pop();
      applyStates(stack[stack.length - 1]);
      focusActivePanel();
    }
  });
})();
